function showMore(e) {
  $(e.currentTarget).closest('div').addClass('v2-hidden');

  $(e.currentTarget)
    .closest('div')
    .siblings('.testimonial-full-text')
    .removeClass('v2-hidden');

  $(e.currentTarget).closest('.v2-testimonials-slider').slick('refresh');
}

function showLess(e) {
  $(e.currentTarget).closest('div').addClass('v2-hidden');

  $(e.currentTarget)
    .closest('div')
    .siblings('.testimonial-truncated-text')
    .removeClass('v2-hidden');

  $(e.currentTarget).closest('.v2-testimonials-slider').slick('refresh');
}

export default function v2TestimonialSlider() {
  // Load Testimonials
  const sliders = $('.v2-testimonials-slider');

  sliders.each((idx, element) => {
    const slider = $(element);
    const nextArrow = slider
      .parent()
      .find('.v2-testimonials-slide-controls__next');
    const prevArrow = slider
      .parent()
      .find('.v2-testimonials-slide-controls__prev');

    slider.slick({
      infinite: true,
      prevArrow: false,
      nextArrow: false,
      dots: false,
      fade: true,
      adaptiveHeight: true
    });

    nextArrow.on('click', () => slider.slick('slickNext'));
    prevArrow.on('click', () => slider.slick('slickPrev'));

    setTimeout(() => slider.slick('setPosition'), 200);
  });

  const testimonialsShowMoreButton = document.querySelectorAll(
    '.testimonial-show-more'
  );

  const testimonialsShowLessButton = document.querySelectorAll(
    '.testimonial-show-less'
  );

  testimonialsShowMoreButton.forEach(function (testimonial) {
    testimonial.addEventListener('click', showMore);
  });

  testimonialsShowLessButton.forEach(function (testimonial) {
    testimonial.addEventListener('click', showLess);
  });
}
